import { LabelButtonMes } from "./style";

export default function LabelMes(props) {
    return <LabelButtonMes variant={props.variant} {...props}>{props.mes}</LabelButtonMes>;
}
